/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Skeleton } from "@mui/material";

export const StyledCircularLoader = styled(Skeleton)({
  width: '100%',
  height: '100%',
})
